<template>
  <div class="idea-challenge">
    <PreContentHeader :show-loading="!contentReady" :error-message="contentLoadError"></PreContentHeader>
    <transition name="fade">
      <div v-if="contentReady && contentLoadError === ''">
        <ContentHeader :name="challenge.title.rendered"></ContentHeader>
        <div v-if="challenge._embedded['wp:featuredmedia'] !== undefined" class="featuredImg">
          <img v-if="challenge._embedded['wp:featuredmedia'][0].media_details.sizes.full.source_url"
            :src="challenge._embedded['wp:featuredmedia'][0].media_details.sizes.full.source_url"
            :alt="challenge._embedded['wp:featuredmedia'][0].alt_text"
            :title="challenge._embedded['wp:featuredmedia'][0].title.rendered"
          >
        </div>
        <div class="card float-xl-right ml-xl-4 my-3">
          <div class="card-body d-flex">
            <i class="fas fa-calendar-alt fa-3x align-self-center" style="opacity: 0.15"></i>
            <div class="pl-3">
              <h5 class="text-uppercase text-black-50 text-center mb-0">Challenge dates</h5>
              {{challenge.idea_challenge_meta[0][0][0].challenge_date_range}}
            </div>
          </div>
        </div>
        <div v-html="challenge.content.rendered" class="mt-3"></div>
        <div v-if="challenge.tabbed_content.length > 0">
          <b-tabs v-if="challenge.tabbed_content[0][0].length > 0">
            <b-tab v-for="tab in challenge.tabbed_content[0][0]" v-bind:key="tab.tab_title.replace(/ /g, '-')" :title="tab.tab_title">
              <div v-html="tab.tab_content" class="mt-2"></div>
            </b-tab>
          </b-tabs>
        </div>
        <transition name="grow">
          <section v-if="challenge.idea_entry_fields[0][0].length > 0 && !submittedIdea" class="submit-idea mt-3">
            <h3 class="mb-4">Get involved by entering your outstanding idea below</h3>
            <form v-on:submit.prevent="">
              <div class="custom-form-fields">
                <NominationField
                  v-for="formField in ideaEntryFields"
                  v-bind:key="formField.index"
                  :type="formField.type"
                  :description="formField.description"
                  :secondary-description="formField.secondaryDescription"
                  :is-required="formField.isRequired"
                  :checkboxLabels="formField.checkboxLabels"
                  v-on:updatedFieldContent="fieldUpdated($event)"
                  :displayField="formField.display_field"
                  :error-class="formField.errorClass">
                </NominationField>
              </div>
              <div class="row py-1">
                <div class="col offset-md-4 offset-lg-4 offset-xl-3">
                  <div class="form-group form-check">
                    <input type="checkbox" id="terms" required="required" class="form-check-input" v-model="termsCheckbox">
                    <label for="terms" class="form-check-label">Accept the
                      <router-link to="/page/hackathon-idea-challenge-terms-and-conditions/" target="_blank">Terms &amp; Conditions</router-link>
                    </label>
                  </div>
                </div>
              </div>
              <div class="row pt-2 mb-4">
                <div class="col offset-md-4 offset-lg-4 offset-xl-3">
                  <button type="submit" class="btn btn-primary btn-lg mb-4" @click="submitIdea">Submit idea</button>
                </div>
              </div>
            </form>
          </section>
        </transition>
        <PreContentHeader :show-loading="creatingIdea" :error-message="createIdeaError"></PreContentHeader>
        <section v-if="submittedIdea">
          <div class="alert alert-success mt-3" role="alert">
            Your idea has been submitted. <br><button type="button" class="btn btn-link p-0" v-on:click="submittedIdea = false">Submit another idea</button>
          </div>
        </section>
      </div>
    </transition>
  </div>
</template>

<script>
import ContentHeader from '@/components/ContentHeader'
import WordpressRestAPI from '@/helpers/WordpressRestAPI.js'
import NominationField from '@/components/NominationField'
import PreContentHeader from '@/components/PreContentHeader'
export default {
  components: {
    PreContentHeader,
    ContentHeader,
    NominationField
  },
  data () {
    return {
      challenge: [],
      contentReady: false,
      contentLoadError: '',
      ideaEntryContent: [],
      ideaEntryFields: [],
      termsCheckbox: false,
      submittedIdea: false,
      creatingIdea: false,
      createIdeaError: ''
    }
  },
  created () {
    this.loadContent()
  },
  methods: {
    readyToSubmitIdea: function () {
      var contentPassedValidation = true
      for (var j = 0; j < this.ideaEntryContent.length; j++) {
        this.ideaEntryFields[j].errorClass = ''
        if (this.ideaEntryContent[j].required.toLowerCase() === 'false' && this.ideaEntryContent[j].content === '' && !this.ideaEntryContent[j].validated) {
          this.ideaEntryContent[j].validated = true
        }
        if (this.ideaEntryContent[j].validated === false) {
          contentPassedValidation = false
          this.ideaEntryFields[j].errorClass = 'field-not-validated'
        }
      }
      return this.termsCheckbox && contentPassedValidation
    },
    submitIdea: function () {
      if (this.readyToSubmitIdea()) {
        this.addIdea()
      }
    },
    setideaEntryContent: function (ideaFields) {
      this.ideaEntryFields = ideaFields.map(function (x, index) {
        return {
          type: x.idea_entry_form_field_type,
          description: x.idea_entry_field_description,
          secondaryDescription: x.idea_entry_field_secondary_description,
          isRequired: x.idea_entry_required,
          checkboxLabels: x.idea_entry_checkbox_labels,
          errorClass: '',
          display_field: true,
          index: index + x.idea_entry_form_field_type}
      })
      this.ideaEntryContent = ideaFields.map(function (x) {
        return {label: x.idea_entry_field_description, content: '', required: x.idea_entry_required, validated: false, displayField: false}
      })
    },
    fieldUpdated: function (fieldDetails) {
      for (var i = 0; i < this.ideaEntryContent.length; i++) {
        if (this.ideaEntryContent[i].label === fieldDetails.label) {
          this.ideaEntryContent[i].content = fieldDetails.content
          this.ideaEntryContent[i].validated = fieldDetails.validated
          break
        }
      }
    },
    setIdeaPostCategories: function () {
      if (this.challenge.idea_chalenge_category[0] === 38) {
        var userSelectedCategories = this.ideaEntryContent.filter(x => x.label.toLowerCase().indexOf('category') > -1).map(y => y.content.replace(/<ul>/g, '').replace(/<\/ul>/g, '').replace(/<\/li><li>/g, ','))[0].replace('<li>', '').replace('</li>', '').split(', ')
      } else {
        var userSelectedCategories = this.challenge.idea_chalenge_category
      }

      return new Promise((resolve, reject) => {
        WordpressRestAPI.getViewContent('idea_chalenge_category?per_page=100')
          .then(response => {
            let filteredCats = []
            for (var i = 0; i < response.data.length; i++) {
              if (userSelectedCategories.includes(response.data[i].name) && this.challenge.idea_chalenge_category[0] === 38) {
                filteredCats.push(response.data[i].id)
              }
              else if (userSelectedCategories.includes(response.data[i].id)) {
                filteredCats.push(response.data[i].id)
              }
            }
            resolve(filteredCats.concat(this.challenge.idea_chalenge_category))
          })
          .catch(e => {
            console.error(e)
            reject(e)
          })
      })
    },
    setIdeaPostContent: function () {
      var content = ''
      for (var i = 0; i < this.ideaEntryContent.filter(x => x.label !== 'If applicable, please attach supporting documentation (Word, PowerPoint, video):').length; i++) {
        content += '<strong>' + this.ideaEntryContent[i].label + '</strong><br><p>' + this.ideaEntryContent[i].content + '</p>'
      }
      return content
    },
    setPostTitle: function () {
      let titleArray = this.ideaEntryContent.filter(x => x.label.toLowerCase().indexOf('title') > -1)
      if (titleArray.length > 0) {
        return titleArray[0].content
      } else {
        return this.$store.getters.getUserName + ' an idea for: ' + this.challenge.title.rendered
      }
    },
    addMediaToIdeaPost: function (mediaID, postID) {
      var sendNomination = {
        method: 'POST',
        data: {
          idea_supporting_documentation: mediaID
        },
        headers: {
          'Authorization': localStorage.getItem('userToken'),
          'Content-Type': 'application/json'
        },
        json: true
      }
      WordpressRestAPI.endpointWithAuthetication(sendNomination, 'idea/' + postID)
        .then(function (response) {
          console.log(response)
        })
        .catch(function (e) {
          console.error(e)
        })
    },
    uploadSupportingDocumentation: function (postID, supportingDoc) {
      var self = this
      var formData = new FormData()
      formData.append('file', supportingDoc)
      formData.append('title', 'Supporting documentation for ' + this.$store.getters.getUserName)
      formData.append('caption', 'Supporting documentation for ' + this.$store.getters.getUserName)
      console.log(formData)
      var uploadMedia = {
        method: 'POST',
        processData: false,
        contentType: false,
        data: formData,
        headers: {
          'Authorization': localStorage.getItem('userToken'),
          'Content-Type': 'application/json'
        },
        json: true
      }
      WordpressRestAPI.endpointWithAuthetication(uploadMedia, 'media')
        .then(function (response) {
          console.log(response)
          self.addMediaToIdeaPost(response.data.id, postID)
        })
        .catch(function (e) {
          console.error(e)
        })
    },
    checkForMediaUpload: function (postID) {
      let supportingDoc = this.ideaEntryContent.filter(x => {
        return x.label.indexOf('supporting documentation') > -1 && x.content !== ''
      })
      if (supportingDoc.length > 0) {
        this.uploadSupportingDocumentation(postID, supportingDoc[0].content)
      }
    },
    addIdea: function () {
      this.creatingIdea = true
      var self = this
      self.setIdeaPostCategories()
        .then(function (challengeCategories) {
          var createIdea = {
            method: 'POST',
            data: {
              title: self.setPostTitle(),
              idea_chalenge_category: challengeCategories.concat(self.challenge.community_categories),
              community_categories: self.challenge.community_categories,
              status: 'publish',
              content: self.setIdeaPostContent(),
              total_likes: 0
            },
            headers: {
              'Authorization': localStorage.getItem('userToken'),
              'Content-Type': 'application/json'
            },
            json: true
          }
          WordpressRestAPI.endpointWithAuthetication(createIdea, 'idea')
            .then(function (response) {
              console.log(response.data)
              console.log(response.status)
              self.checkForMediaUpload(response.data.id)
              self.submittedIdea = true
              self.creatingIdea = false
            })
            .catch(function (e) {
              self.contentLoadError = 'Oops! We had a problem with uploading your entry. Please try again later.'
              self.creatingIdea = false
              self.createIdeaError = 'Oops! We had a problem with uploading your entry. Please try again later.'
              console.error(e)
            })
        })
        .catch(function (e) {
          self.contentLoadError = 'Oops! We had a problem with uploading your entry. Please try again later.'
          self.creatingIdea = false
          self.createIdeaError = 'Oops! We had a problem with uploading your entry. Please try again later.'
          console.error(e)
        })
    },
    loadContent: function () {
      document.title = this.$route.params.name.replace(/-/g, ' ') + ' - ThinkTank'
      WordpressRestAPI.getViewContent('idea_challenge?idea_chalenge_category_exclude=10&slug=' + this.$route.params.name + '&_embed')
        .then(response => {
          this.challenge = response.data[0]
          if (response.data[0].idea_entry_fields.length > 0) {
            this.setideaEntryContent(response.data[0].idea_entry_fields[0][0])
          }
          this.contentReady = true
        })
        .catch(e => {
          this.contentLoadError = 'Oops! We had a problem with loading this Idea challenge. Please try again later.'
          console.error(e)
          this.contentReady = true
        })
    }
  },
  watch: {
    '$route' (to, from) {
      this.contentReady = false
      this.loadContent()
    }
  }
}
</script>

<style lang="less">
  .tab-content {
    background: white;
    border: 1px solid #dee2e6;
    border-top: none;
    padding: 10px;
  }
  .custom-form-fields {
    .form-check {
      width: 100% !important
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/routes/IdeaChallenge.vue